<template>
  <v-app :class="template.app_class" v-resize="onResize" :id="supplier_slug">
    <layout-header-nav-bar v-if="template.header_display && instance.status !== 'locked'" />
    <panel-left v-if="template.panel_left" />
    <v-main v-if="instance.status !== 'locked'">
      <call-waiter
        :tableId="tableId"
        ref="callWaiterComponent"
        v-if="((is_ontable_checkout || is_ontable_noincremental) && tableId !=='' && !is_room_service) && !template.loading && instance.slug !== ('rayados' || 'rayados-mty')"
      />
      <router-view
        v-if="instance.suppliers.length > 0"
        @callWaiter="$refs.callWaiterComponent.callTheWaiter()"
      />
    </v-main>
    <rate-tab
      :instance="instance"
      :profile="profile"
      v-if="
        supplier.on_table_class == 'basic' &&
        (service === 'on_table' && subservice !== 'room') &&
        !template.loading && ($route.name === 'OnTableHome' || $route.name === 'Menu') &&
        (instance.rate_digitalmenu || instance.rate_nps)"
    />
    <service-cookies v-if="!legal.check_cookies && instance.id !== undefined && instance.id !== null && instance.id.toString().length > 0" />
    <loader-splash v-if="template.loading" />
    <alert-add-to-my-list
      v-if="openAlertList === true"
      :openAlertList="openAlertList"
    />
    <inactive-instance v-if="instance.status === 'locked'" :instance="instance" />
    <pop-ups :see-product="seeProduct" v-if="validatePopupModule && supplier.id > 0 && service"></pop-ups>
    <modal-product  @closeProduct="closeProduct" v-if="seeProduct" />
    <screen-size-sheet v-if="false" />
    <error-dialog
      v-if="error.show"
      :data="error"
      @DismissErrorDialog="dismissErrorDialog"
    />
    <validate-coverage
      v-if="confirmationLocation && service === 'delivery'"
      :shoppingCart="shoppingCart"
      @pay="pay()"
      @getShoppingCart="getShoppingCart()"
      @closeConfirmationLocation="closeConfirmationLocation()"
    />
  </v-app>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { profile } from "./services/profile";
import { vuetifyCustom } from "./services/vuetify-custom";
import { track } from "./services/track-custom";
import PanelLeft from "./components/layout/PanelLeft";
import LoaderSplash from "./components/layout/LoaderSplash";
import LayoutHeaderNavBar from "./components/layout/HeaderNavBar";
import InactiveInstance from "./components/layout/InactiveInstance.vue";
import { deliveryOrderMixin } from "@/mixins/deliveryOrderMixin.js";

const AlertAddToMyList = () => import(/* webpackChunkName: "alertAddToMyList" */  '@/components/producto/AlertAddToMyList');
const CallWaiter = () => import(/* webpackChunkName: "callWaiter" */  '@/components/on_table/CallWaiter');
const ScreenSizeSheet = () => import(/* webpackChunkName: "screenSizeSheet" */  '@/components/share/ScreenSizeSheet');
const ModalProduct = () => import(/* webpackChunkName: "modalProduct" */  '@/views/product/ModalProduct');
const RateTab = () => import(/* webpackChunkName: "rateTab" */  '@/views/on_table/RateExpMenu/RateTab');
const PopUps = () => import(/* webpackChunkName: "popUps" */  '@/components/publicidad/PopUps');
const ServiceCookies = () => import(/* webpackChunkName: "serviceCookies" */  '@/components/legal/ServiceCookies');
const ErrorDialog = () => import(/* webpackChunkName: "ErrorDialog" */ "@/components/cluvi-pay/ErrorDialog.vue");

export default {
  name: "App",
  metaInfo: {
    title: "Cluvi",
    titleTemplate: "%s",
    meta:[
      {vmid: "description", name:'description', content:`timestamp: ${process.env.VUE_APP_TIMESTAMP}`},
      {property: 'og:timestampbuild', content:process.env.VUE_APP_TIMESTAMP}
    ]
  },
  data: () => ({
    params: {},
    seeProduct: false,
    supplier_slug: '',
    menuDigitalView: false
  }),
  async created() {
    await profile.init();
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get("service") !== undefined && urlParams.get("service") !== null) this.setService(urlParams.get("service"));
    this.SetProductId(null);
    this.SetLoading(true);
    this.setAllowGps(false);
    await this.InitInstance();
    vuetifyCustom.init(this, this.instance);
    track.load();
    this.CloseLeftPanel();
    this.onResize();
    this.setLang();
    this.SetInitToMenu(false);
    this.createAcquisition();
    if (this.confirmationLocation === true) this.closeConfirmationLocation();
  },
  components: {
    PopUps,
    LayoutHeaderNavBar,
    LoaderSplash,
    PanelLeft,
    ServiceCookies,
    InactiveInstance,
    AlertAddToMyList,
    ModalProduct,
    CallWaiter,
    ScreenSizeSheet,
    RateTab,
    ErrorDialog,
    ValidateCoverage: () => import(/* webpackChunkName: "ValidateCoverage" */'@/components/delivery/SetLocation/ValidateCoverage.vue')
  },
  mixins: [ deliveryOrderMixin ],
  methods: {
    ...mapMutations('template', ['CloseLeftPanel', 'SetLoading', 'SetInitToMenu']),
    ...mapMutations('profile', ['setAllowGps' ]),
    ...mapMutations('order', ['setService','SetCountProductsList']),
    ...mapMutations('shared', ['setWindowSize', 'SetProductId', 'setLanguage', 'setError']),
    ...mapActions('customer',["InitInstance"]),
    onResize() {
      this.setWindowSize({
        x: window.innerWidth,
        y: window.innerHeight,
        is_movile: null
      });
    },
    setLang() {
      const langInstance = this.instance.language.toLowerCase();
      if(this.lang !== '') {
        this.setI18nFileByLang(this.lang)
      }else if (['es', 'en', 'pt'].includes(langInstance)) {
        this.setLanguage(langInstance);
        this.setI18nFileByLang(langInstance)
      } else {
        this.setLanguage('es');
        this.setI18nFileByLang('es');
      }
    },
    closeProduct() {
      this.SetProductId(null);
      this.seeProduct = false;
    },
    createAcquisition(){
      if(this.instance.id !== null && this.instance.id !== undefined && this.session.id !== null && this.session.id !== undefined && this.session.id.length > 0){
        track.storeAcquisitionData(window.location.search,this.session.id,this.instance.id)
      }else{
        setTimeout( () =>{this.createAcquisition()}, 1500)
      }
    },
    setI18nFileByLocale(locale) {
      switch (locale) {
        case "pt-BR":
          this.$i18n.locale = "pt";
          break;
        case "en-US":
          this.$i18n.locale = "en";
          break;
        default:
          this.$i18n.locale = "es";
      }
    },
    setI18nFileByLang(lang) {
      this.$i18n.locale = lang
    },
    dismissErrorDialog() {
      this.error.show = false;
    }
  },
  computed: {
    ...mapState('shared', ['legal', 'product_id', 'windowSize', 'lang', 'error']),
    ...mapState('customer', ['instance', 'supplier']),
    ...mapState('template', ['template', 'loading']),
    ...mapState('ontable', ['openAlertList','tableId']),
    ...mapState('order', ['service','subservice','countProductsList',"purchaseId"]),
    ...mapState('profile',['session','profile']),
    ...mapGetters('order', ["is_room_service"]),
    ...mapGetters('customer', ["is_ontable_plazoleta","is_ontable_checkout","is_ontable_noincremental", "is_ontable_basic"]),
    validatePopupModule(){
      return !(this.$route.name === "Main"||
          this.$route.name === "Location"||
          this.$route.name === "BranchOnTable"||
          this.$route.name === "BranchToTakeAway"||
          this.$route.name === "BranchWithOutService"||
          this.$route.name === "BranchToBook")
    }
  },
  watch: {
    supplier: function(val) {
      if(val.slug !== undefined && val.slug !== null){
        this.supplier_slug = val.slug;
      }
      if (
        val.locale === undefined ||
        val.locale === null ||
        val.locale === "" ||
        val.locale === this.$i18n.locale
      ) {
        return;
      }
      this.setI18nFileByLang(this.instance.langs.length ? this.lang : val.locale);
    },
    product_id: function(val) {
      if (val === null || val === undefined || val.toString().length <= 1) {
        this.seeProduct = false;
        this.params = {};
      } else {
        this.params = {
          supplier_id: this.supplier.slug,
          product_id: this.product_id
        };
        this.seeProduct = true;
      }
    },
    $route() {
      if(this.$route.name === 'OnTableMenuDigital') this.menuDigitalView = true;
      else this.menuDigitalView = false;
      this.$vuetify.theme.dark = this.instance.theme.dark;
    }
  }
};
</script>

<style lang="scss">
  @import "styles/custom.scss";
  $fa-font-path : "styles/fontawesome/webfonts";
  @import "styles/fontawesome/css/all.min.css";
  @import "styles/fontawesome/css/sharp-light.min.css";
  @import "styles/fontawesome/css/sharp-regular.min.css";
  @import "styles/fontawesome/css/sharp-solid.min.css";
  footer {
    background-color: transparent !important;
  }
</style>
